

export default class LevelTranslationsUpdateRequest  {
	LangCode?: string = '';
	Name?: string = '';
	constructor(obj?: Partial<LevelTranslationsUpdateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
